import Icon from '../components/Icon.vue'

Icon.register({"minus":{"width":448,"height":512,"paths":[{"d":"M424 318.2C437.3 318.2 448 307.5 448 294.2V217.8C448 204.5 437.3 193.8 424 193.8H24C10.7 193.8 0 204.5 0 217.8V294.2C0 307.5 10.7 318.2 24 318.2H424z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/minus.js
// module id = null
// module chunks = 